import { axios } from '../../utilities/axiosClient'
import { Notification } from '../../types/Notification'

export const getNotification = (): Promise<Notification> =>
  axios.get('/api/info')
